import React, { useEffect, useState } from 'react';
import api from '../services/api';

function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/hdp/audit-logs')
      .then((res) => setLogs(res.data.audit_logs || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <header className="main-header">
        <h1 className="page-title">Audit Log</h1>
      </header>
      <div className="main-body">
        <div className="card" style={{ marginBottom: 'var(--spacing-lg)' }}>
          <div className="card-body">
            <p style={{ color: 'var(--text-muted)', margin: 0 }}>
              Audit entries are append-only and cannot be deleted. They provide a permanent record of platform actions for compliance and transparency.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            {loading ? (
              <p style={{ color: 'var(--text-muted)' }}>Loading audit log...</p>
            ) : logs.length === 0 ? (
              <p style={{ color: 'var(--text-muted)' }}>No HDP audit events recorded yet.</p>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Resource</th>
                    <th>IP</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.action}</td>
                      <td>{log.resource_type} {log.resource_id ? `· ${log.resource_id.slice(0, 8)}` : ''}</td>
                      <td>{log.ip_address || '—'}</td>
                      <td>{log.timestamp && new Date(log.timestamp).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AuditLog;
